import type { FC } from 'react';
import { useState } from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { triggerBulkBuyingPromotionModalClosed } from 'Services/analytics/events/bulkBuyingPromotionEvents';

import { PromotionsBannerModal } from './PromotionsBannerModal/PromotionsBannerModal';
import texts from './PromotionsBanner.texts';
import { useDiscountValues } from './useDiscountValues';

import styles from './PromotionsBanner.module.scss';

const LocalT = new MDText(texts);

export const PromotionsBanner: FC<{ containerClassName?: string; onExplanationClick: () => void }> = ({
	containerClassName,
	onExplanationClick,
}) => {
	const [shouldShowHowItWorksModal, setShouldShowHowItWorksModal] = useState(false);
	const discountValues = useDiscountValues();

	if (!discountValues) {
		return null;
	}

	return (
		<div className={cx([styles.container, styles.hideOnMobile, containerClassName])}>
			{shouldShowHowItWorksModal && (
				<PromotionsBannerModal
					discountValues={discountValues}
					onDismissModal={() => {
						triggerBulkBuyingPromotionModalClosed();
						setShouldShowHowItWorksModal(false);
					}}
				/>
			)}
			<div className={styles.imageAndTextContainer}>
				<div className={styles.image} />
				<div className={styles.textContainer}>
					<h3>{LocalT.translate(texts.title, { percentageDiscount: discountValues.percentageDiscount })}</h3>
					<p>
						{LocalT.translate(texts.description, {
							percentageDiscount: discountValues.percentageDiscount,
							purchaseThreshold: discountValues.purchaseThreshold,
						})}
					</p>
				</div>
			</div>
			<div className={styles.button}>
				<Button
					fullWidth
					className={styles.innerButton}
					label={LocalT.translate(texts.button)}
					onClick={() => {
						onExplanationClick?.();
						setShouldShowHowItWorksModal(true);
					}}
					size="medium"
					variant="secondary"
				/>
			</div>
		</div>
	);
};
